import { gameLoop } from "appworks/core/game-loop";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { Rectangle } from "appworks/utils/geom/rectangle";
import Logger = require("js-logger");
import { Signal } from "signals";
import { slotModel } from "slotworks/model/slot-model";
import { PartnerConnectManager } from "./partner-connect-manager";

export interface YggUiElement {
    id: string;
    bounds: Rectangle;
}

export interface YggUiSpace {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export class PartnerConnectEvents {
    public static onUiChanged: Signal = new Signal();
    public static onYggUiChanged: Signal = new Signal();
    public static onBalanceChanged: Signal = new Signal();
    public static onInitSpin: Signal = new Signal();
    public static onShowRules: Signal = new Signal();
    public static uiElements: YggUiElement[] = [];
    public static yggUiSpace: YggUiSpace;

    public closeGameSession = (): boolean => {
        return !Services.autoplay.isAutoPlaying();
    }

    public disableAudio = (): void => {
        Services.sound.mute();
    }

    public enableAudio = (): void => {
        Services.sound.unmute();
    }

    public errorPopupClosed = (id: string): void => {
        gameLoop.setPaused("errorPopup", false);
    }

    public errorPopupOpened = (id: string): void => {
        gameLoop.setPaused("errorPopup", true);
    }

    public getAudioVolume = (): number => {
        return Services.sound.getVolume();
    }

    public getBalance = (): number => {
        return Services.transaction.getBalance() / 100;
    }

    public initSpin = (): void => {
        if (uiFlags.has(UIFlag.IDLE) && !uiFlags.has([UIMenuFlag.MENU, UIMenuFlag.AUTO, UIFlag.AUTO_SPIN, UIFlag.PROMPT])) {
            PartnerConnectEvents.onInitSpin.dispatch();
        }
    }

    public openGameRules = (): void => {
        PartnerConnectEvents.onShowRules.dispatch();
    }

    public pauseGame = (): void => {
        gameLoop.setPaused("partner-connect", true);
        uiFlags.set(UIFlag.EXTERNAL_DISABLE, true);
    }

    public resize = (): void => {
        // Do nothing
    }

    public resumeGame = (): void => {
        gameLoop.setPaused("partner-connect", false);
        uiFlags.set(UIFlag.EXTERNAL_DISABLE, false);
    }

    public setMinBet = (): void => {
        const model = slotModel.read();
        model.bet.creditSizes.currentValue = model.bet.creditSizes.values[0];
        slotModel.write(model);
    }

    public skipSplashScreen = (): void => {
        PartnerConnectManager.skipSplashScreen = true;
        PartnerConnectManager.onSkipSplashScreen.dispatch();
    }

    public skipVideoIntro = (): void => {
        // Do nothing
    }

    public stopAutoSpin = (): void => {
        Services.autoplay.stop();
    }

    public stopReplay = (): void => {
        // Do nothing
    }

    public updateGameBalance = (balance: { cash: number, won?: boolean }): void => {
        gameState.getCurrentGame().balance = Math.round(balance.cash * 100);
        PartnerConnectEvents.onBalanceChanged.dispatch();
    }

    public willClosingGameLeaveUnfinishedGame() {
        PartnerConnectManager.getEmitters().willClosingGameLeaveUnfinishedResponse(!uiFlags.has(UIFlag.IDLE));
    }

    public uiChanged = (uiElements: YggUiElement[]): void => {
        Logger.info("PartnerConnect.uiChanged uiElements: ", uiElements);
        PartnerConnectEvents.uiElements = uiElements;
        PartnerConnectEvents.onUiChanged.dispatch(uiElements);
    }

    public yggUIChanged = (yggUiSpace: YggUiSpace): void => {
        Logger.info("PartnerConnect.yggUIChanged yggUiSpace: ", yggUiSpace);
        PartnerConnectEvents.yggUiSpace = yggUiSpace;
        PartnerConnectEvents.onYggUiChanged.dispatch(yggUiSpace);
    }
}
